<template>
	<div style="margin-top: 90px;">
		<Nav/>
    <Fix />
<!--		<Banner/>-->
		<div class="container" v-if="products && products.length">
<!--			<el-breadcrumb separator="/" class="top">-->
<!--				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--				<el-breadcrumb-item>产品</el-breadcrumb-item>-->
<!--			</el-breadcrumb>-->
			<el-card class="top">
				<div class="left">
					<!-- 产品横向逐一展示 -->
					<div v-for="product in products" :key="product.id" class="product-card" @click="viewDetails(product.id)">
						<el-image :src="product.mainImage" :alt="product.name" fit="fill" />
						<div class="product-name">
              {{ product.name }}
            </div>
<!--            <p>¥{{ product.price }}元</p>-->
					</div>
				</div>
			</el-card>
		</div>
		<Footer class="top"/>
	</div>
</template>

<script>
import Banner from './components/Banner'
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import { getAllProducts } from '@/api/index.js'
import Fix from "@/views/front/components/Fixed.vue";

export default {
    name: 'ProductService',
    components: {Fix, Nav, Footer, Banner},

    data() {
        return {
            products: []
        };
    },

    mounted() {
        this.fetchProducts();
    },

    methods: {
      fetchProducts() {
        getAllProducts().then(response => {
                this.products = response.data; // 访问response.data
            }).catch(error => {
                console.error('Failed to fetch products:', error);
            });
        },
        viewDetails(id) {
          this.$router.push({ name: 'ProductDetail', params: { id } });
        }
    },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // Ensure the page takes at least the full height of the viewport
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
}

.container {
  flex: 1; // Allow the container to grow and fill available space
  //margin-bottom: 100px; // Add space between container and footer
}

.left {
  display: flex;
  flex-wrap: wrap;
  //gap: 20px;
}

.product-card {
  width: 300px;
  border: 1px solid #e1e1e1;
  padding: 10px;
  text-align: center;
  margin: 0 10px 0 0;
  cursor: pointer;
  p {
    color: red;
    font-weight: bold;
  }

  .el-image {
    width: 100%;
    height: auto;
  }

  .product-name{
    width: 100%;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
    font-weight: bold;
  }
}

@media (max-width: 768px) {
  .product-card {
    width: 100%;
    margin: 0 0 20px 0;

    .el-image {
      width: 100%;
    }

    .product-name {
      width: 100%;
      text-wrap: wrap;
    }
  }
}

//@media (min-width: 769px) {
//  .product-card {
//    width: calc(33.33% - 20px);
//  }
//
//  .left {
//    display: flex;
//    flex-wrap: wrap;
//  }
//}
</style>
